import { usePreferences } from "@/composables/usePreferences";

const { getPreferences, setPreferences, removePreferences } = usePreferences();

export const useAssistantStorage = () => {
  const assistantStorage = {
    async getItem(key: string) {
      const { value } = await getPreferences({ key });
      return value;
    },
    async setItem(key: string, value: string) {
      await setPreferences({ key, value });
    },
    async removeItem(key: string) {
      await removePreferences({ key });
    },
  };

  return {
    assistantStorage,
  };
};
